import { Component } from '@angular/core';
import {
	FieldWorkerMultipleUnavailableDay,
	unavailableDayMultipleFormConfig,
} from '../unavailable-multiple-days/unavailable-multiple-days.component';
import { NgControl, FormBuilder } from '@angular/forms';
import { CustomFormAccessor } from '../../form-cva.component';
import { FieldWorkerUnavailableDay } from 'src/shared/api';
import { takeUntil } from 'rxjs/operators';

@Component({
	selector: 'rpshared-unavailable-multi-delete',
	templateUrl: './unavailable-multi-delete.component.html',
	styleUrls: ['./unavailable-multi-delete.component.scss'],
})
export class UnavailableMultiDeleteComponent extends CustomFormAccessor<
	FieldWorkerMultipleUnavailableDay
> {
	constructor(public ngControl: NgControl, public fb: FormBuilder) {
		super(ngControl, fb, unavailableDayMultipleFormConfig);
	}

	// model --> view
	writeValue(value: FieldWorkerUnavailableDay): void {
		super.writeValue(value);
	}

	// view --> model
	registerOnChange(fn: (value: FieldWorkerUnavailableDay) => void) {
		this.form.valueChanges.pipe(takeUntil(this.destroyed)).subscribe(fn);
	}
}
